import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useCompany } from '@/hooks/useCompany';
import { isPlatformAdminAllowedPath, PLATFORM_ADMIN_ALLOWED_PATHS } from './platformAdminPaths';

export { PLATFORM_ADMIN_ALLOWED_PATHS };

const PlatformAdminViewGuard = () => {
  const { isPlatformAdminView, loading } = useCompany();
  const location = useLocation();

  // Never return null — that would unmount OnboardingGuard and trigger a re-check.
  // Redirect only once loading has resolved and we know the user is in Platform Admin View.
  if (!loading && isPlatformAdminView && !isPlatformAdminAllowedPath(location.pathname)) {
    return <Navigate to="/review" replace />;
  }

  return <Outlet />;
};

export default PlatformAdminViewGuard;
